<template>
	<section class="section" :name="data.name">
		<div class="section__header" @click="toggleSection($event, data.name)">
			<div class="section__main">
				<div class="section__headline">{{ data.headline }}</div>
			</div>
			<div class="section__control">
				<button class="section__button" @click.stop="toggleSection($event, data.name)">
					<span
						:class="[data.extended ? 'section__button-icon section__button-icon_rotate' : 'section__button-icon']"
					></span>
				</button>
			</div>
		</div>
		<div class="section__body" v-show="data.extended">
			<slot name="content"></slot>
			<div class="section__footer">
				<Button
					:type="'text'"
					:value="'Отмена'"
					:paint="'gray'"
					:disabled="data.cancellation"
					@click="cancelSection($event, data.name)"
				/>
				<Button
					:type="'text'"
					:value="'Сохранить изменения'"
					:paint="'blue'"
					:disabled="!data.validation"
					@click="applySection($event, data.name)"
				/>
			</div>
		</div>
	</section>
</template>

<script>
import Button from "../components/Button";
export default {
	name: "Section",
	props: {
		data: Object,
	},
	components: {
		Button,
	},
	methods: {
		toggleSection(event, payload) {
			this.$emit("sctoggle", payload);
		},
		cancelSection(event, payload) {
			this.$emit("sccancel", payload);
		},
		applySection(event, payload) {
			this.$emit("scapply", payload);
		},
	},
};
</script>

<style lang="scss" scoped>
.section {
	@include base;

	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 20px 20px;

	&__header {
		display: flex;
		justify-content: space-between;
		width: 100%;
		cursor: pointer;
	}

	&__headline {
		font-size: 12px;
		font-weight: 500;
		text-transform: uppercase;
	}

	&__badge {
		margin-left: 5px;
		background-color: #41c6eb;
		color: #fff;
		border-radius: 10px;
		padding: 3px 7px;
		font-size: 10px;
	}

	&__main {
		display: flex;
		align-items: center;
	}

	&__control {
		display: flex;
		align-items: center;
	}

	&__button {
		position: relative;
		background: none;
		padding: 0;
		border: 0;
		height: 11px;
		width: 11px;
		cursor: pointer;
		margin-left: 10px;

		&-icon {
			position: absolute;
			left: 2px;
			top: 0px;
			width: 7px;
			height: 7px;
			border: solid #bcbcbc;
			border-width: 0 2px 2px 0;
			transform: rotate(45deg);

			&_rotate {
				border-color: #222325;
				top: 3px;
				transform: rotate(225deg);
			}
		}
	}

	&__footer {
		display: flex;
		justify-content: flex-end;
		flex-direction: column;
		margin-top: 20px;

		button {
			width: 100%;
			margin-bottom: 10px;
		}

		@include mediaquery(sm) {
			flex-direction: row;

			button {
				width: auto;
				margin-bottom: 0;

				&:first-of-type {
					margin-right: 10px;
				}
			}
		}
	}
}
</style>
